<template>
  <normal-dialog
    :visible="visible"
    :close-on-click-modal="selected.isSkip?true:false"
    :show-close="selected.isSkip?true:false"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    class="OperAccount-PayDialog"
    width="750px"
  >
    <template slot="title">
      服务费缴纳
    </template>
    <form-area title="信息">
      <form-line class="pay-info">
        <div>尊敬的用户：</div>
        <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;你好!您的平台服务费已生成，为不影响设备正常使用，请<template v-if="selected.payTimeLimit>0">在{{selected.payTimeLimit}}个自然日内</template>及时缴费，谢谢～</div>
      </form-line>
      <form-line class="pay-money">
        <span class="pay-money-price">¥{{selected.rechargeBalance?selected.rechargeBalance.toFixed(2):'0.00'}}元</span>
        <span
          v-if="showDetailButton"
          class="pay-money-detail"
          @click="showDetailDialog"
        >查看详情</span>
      </form-line>
      <form-line class="payType">
        <el-radio
          class="payType-item"
          v-model="selected.rechargeType"
          @input="showQRCodeHandle"
          label="2"
        >
          <div class="payType-item-icon">
            <img src="../../assets/images/user/wechat.png" />
          </div>
          <div class="payType-item-title">微信支付</div>
        </el-radio>
        <!-- <el-radio
          class="payType-item"
          v-model="selected.rechargeType"
          @input="showQRCodeHandle"
          label="3"
        >
          <div class="payType-item-icon">
            <img src="../../assets/images/user/alipay.png" />
          </div>
          <div class="payType-item-title">支付宝</div>
        </el-radio> -->
      </form-line>
      <form-line>
        <el-radio-group v-model="selected.billType">
          <el-radio
            v-for="(item, index) in billTypeOptions"
            :key="index"
            :label="item.value"
          >{{item.label}}</el-radio>
        </el-radio-group>
      </form-line>
      <form-line>
        <el-checkbox
          v-model="selected.isAgree"
          @input="showQRCodeHandle"
        >同意条款 <span @click.stop="showPayInfoDialog">《缴费条款》</span></el-checkbox>
      </form-line>
      <form-line :class="`qrWrap ${selected.payQrUrl?'show':''}`">
        <canvas id="PayQRcode"></canvas>
      </form-line>
    </form-area>

    <div slot="footer">
      <!-- <el-button
        type="primary"
        @click="submitUpdateHandle"
        :disabled="loading"
      >确定</el-button> -->
      <el-button
        v-if="selected.isSkip"
        @click="cancelHandle"
      >取消</el-button>
    </div>

  </normal-dialog>
</template>

<script>
import dialogMixin from '../../mixins/dialog';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    addDetailItem: { type: Function },
    delDetailItem: { type: Function },
    billTypeOptions: { type: Array },
    showPayInfoDialog: { type: Function },
    showDetailDialog: { type: Function },
    showDetailButton: { type: Boolean },
  },
  mixins: [dialogMixin],
  computed: {
    filterList() {
      return this.selected.details.map(item => item.awardType);
    },
  },
  methods: {
    showQRCodeHandle() {
      if (
        this.selected.rechargeType &&
        this.selected.billType &&
        this.selected.isAgree
      ) {
        this.submitUpdateHandle();
      }
    },
  },
};
</script>

<style lang="scss">
.OperAccount-PayDialog {
  .pay-info {
    display: block;
  }
  .rechargeConfig-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    .el-radio__label {
      line-height: 24px;
      padding: 0;
    }
    .el-radio__input {
      display: none;
    }
    .rechargeConfig-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 180px;
      height: 60px;
      margin: 0 20px 20px;
      padding: 0;
    }
  }
  .pay-money {
    justify-content: center;
    .pay-money-price {
      color: red;
      font-size: 24px;
    }
    .pay-money-detail {
      color: #666;
      margin-left: 14px;
      cursor: pointer;
    }
  }
  .payType {
    flex-wrap: wrap;
    .payType-item {
      display: flex;
      width: 100%;
      height: 40px;
      margin: 0;
      .el-radio__label {
        display: flex;
        align-items: center;
        flex: 1;
        order: 1;
      }
      .el-radio__input {
        order: 2;
        line-height: 40px;
      }
      .payType-item-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
    }
  }

  .qrWrap {
    display: none;
    &.show {
      display: flex;
      justify-content: center;
    }
  }
  .FormLine {
    height: auto;
  }
}
</style>

